import React from 'react';
import { useNavigate } from 'react-router-dom';
import SalaryCalculator from './SalaryCalculator';
import AppFooter from '../Footers/AppFooter';
import { AppContainer } from '../UI/Container';
import { useResponsive } from '../UI/ResponsiveContext';
import { NURSE_SALARY_PATH, SPECIALIST_DOCTOR_SALARY_PATH, TEMP_NURSE_SALARY_PATH, TEMP_DOCTOR_SALARY_PATH, REGISTRATION_PATH } from '../../utils/Constants/Paths';

const SalaryCalculatorPage = () => {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  return (
    <>
      <AppContainer style={{ minHeight: '85vh', marginTop: isMobile ? 8 : 32, marginBottom: 64 }}>
        <section style={{ maxWidth: 900, margin: '0 auto', background: !isMobile && '#fff', borderRadius: 16, boxShadow: !isMobile && '0 4px 24px rgba(0,0,0,0.07)', padding: !isMobile && 32 }}>
          <h1 style={{ 
            marginTop: 0, 
            marginBottom: isMobile ? 8 : 16, 
            fontSize: isMobile ? '1.4rem' : '2.2rem', 
            fontWeight: 700, 
            color: '#222', 
            textAlign: 'center',
            lineHeight: isMobile ? '1.3' : '1.2'
          }}>
            {isMobile ? 'Lönekalkylator för aktiebolag' : 'Kalkylator för aktiebolag - räkna lön, utdelning och skatter'}
          </h1>
          <p style={{ 
            fontSize: isMobile ? '0.9rem' : '1.15rem', 
            color: '#444', 
            textAlign: 'center', 
            marginBottom: isMobile ? 12 : 16,
            lineHeight: isMobile ? '1.4' : '1.5'
          }}>
            {isMobile ? '🚀 Räkna lön, utdelning och skatt för ditt aktiebolag' : '🚀 Få stenkoll på din totala ersättning, lön, utdelning och skatt – för dig som fakturerar via eget aktiebolag.'}
          </p>
          <style>
            {`
              /* === GLOBAL MOBILE FIXES === */
              @media (max-width: 768px) {
                /* Prevent horizontal scrolling on mobile globally */
                html, body {
                  overflow-x: hidden !important;
                  width: 100% !important;
                  max-width: 100vw !important;
                  box-sizing: border-box !important;
                }
                
                /* Ensure all content respects viewport width */
                * {
                  max-width: 100% !important;
                  box-sizing: border-box !important;
                }
              }
              
              /* === APPLE HIG DESIGN SYSTEM === */
              /* Typography scale - Apple HIG inspired */
              :root {
                --font-family-system: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                
                /* Apple HIG Color System */
                --color-primary: #ff5a5a;
                --color-primary-hover: #e04444;
                --color-secondary: #5856D6;
                --color-accent: #FF3B30;
                --color-success: #30D158;
                --color-warning: #FF9500;
                
                /* Text colors */
                --color-text-primary: #1D1D1F;
                --color-text-secondary: #6E6E73;
                --color-text-tertiary: #8E8E93;
                
                /* Background colors */
                --color-bg-primary: #FFFFFF;
                --color-bg-secondary: #F2F2F7;
                --color-bg-tertiary: #E5E5EA;
                --color-bg-grouped: #F2F2F7;
                
                /* Border and separator */
                --color-separator: #C6C6C8;
                --color-border: #D1D1D6;
                
                /* Typography */
                --font-size-large-title: 34px;
                --font-size-title-1: 28px;
                --font-size-title-2: 22px;
                --font-size-title-3: 20px;
                --font-size-headline: 17px;
                --font-size-body: 17px;
                --font-size-callout: 16px;
                --font-size-subhead: 15px;
                --font-size-footnote: 13px;
                --font-size-caption-1: 12px;
                --font-size-caption-2: 11px;
                
                /* Spacing (8pt grid) */
                --spacing-xs: 4px;
                --spacing-sm: 8px;
                --spacing-md: 16px;
                --spacing-lg: 24px;
                --spacing-xl: 32px;
                --spacing-xxl: 48px;
                
                /* Border radius */
                --radius-sm: 8px;
                --radius-md: 12px;
                --radius-lg: 16px;
                --radius-xl: 20px;
                
                /* Shadows */
                --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.12);
                --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
                --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
              }

              /* === LAYOUT COMPONENTS === */
              .apple-calc-container {
                font-family: var(--font-family-system);
                max-width: 1024px;
                margin: 0 auto;
                padding: 8px var(--spacing-xl) var(--spacing-xl) var(--spacing-xl);
                box-sizing: border-box;
                /* Prevent horizontal scrolling on mobile */
                overflow-x: hidden;
                width: 100%;
              }

              .apple-calc-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: var(--spacing-xl);
                margin-bottom: var(--spacing-xxl);
              }

              @media (max-width: 768px) {
                .apple-calc-container {
                  padding: 8px var(--spacing-md) var(--spacing-md) var(--spacing-md);
                  /* Ensure full width and prevent horizontal scrolling */
                  overflow-x: hidden;
                  width: 100vw;
                  max-width: 100vw;
                  box-sizing: border-box;
                }
                
                .apple-calc-grid {
                  grid-template-columns: 1fr;
                  gap: var(--spacing-lg);
                  margin-bottom: var(--spacing-xl);
                }
                
                /* Prevent horizontal scrolling on the entire page for mobile */
                body {
                  overflow-x: hidden;
                  width: 100%;
                  max-width: 100vw;
                }
              }

              /* === CARDS === */
              .apple-calc-card {
                background: var(--color-bg-primary);
                border-radius: var(--radius-lg);
                padding: var(--spacing-xl);
                box-shadow: var(--shadow-md);
                border: 1px solid var(--color-separator);
                box-sizing: border-box;
              }

              .apple-calc-card-header {
                margin-bottom: var(--spacing-lg);
                padding-bottom: var(--spacing-md);
                border-bottom: 1px solid var(--color-separator);
              }

              /* === TYPOGRAPHY === */
              .apple-calc-title-1 {
                font-size: var(--font-size-title-1);
                font-weight: 700;
                color: var(--color-text-primary);
                margin: 0 0 var(--spacing-sm) 0;
                line-height: 1.2;
                letter-spacing: -0.02em;
              }

              .apple-calc-title-2 {
                font-size: var(--font-size-title-2);
                font-weight: 600;
                color: var(--color-text-primary);
                margin: 0 0 var(--spacing-md) 0;
                line-height: 1.3;
                letter-spacing: -0.01em;
              }

              .apple-calc-title-3 {
                font-size: var(--font-size-title-3);
                font-weight: 600;
                color: var(--color-text-primary);
                margin: 0 0 var(--spacing-sm) 0;
                line-height: 1.3;
              }

              .apple-calc-headline {
                font-size: var(--font-size-headline);
                font-weight: 600;
                color: var(--color-text-primary);
                margin: 0 0 var(--spacing-xs) 0;
                line-height: 1.4;
              }

              .apple-calc-body {
                font-size: var(--font-size-body);
                font-weight: 400;
                color: var(--color-text-primary);
                line-height: 1.47;
                margin: 0;
              }

              .apple-calc-subhead {
                font-size: var(--font-size-subhead);
                font-weight: 400;
                color: var(--color-text-secondary);
                line-height: 1.4;
                margin: 0 0 var(--spacing-xs) 0;
              }

              .apple-calc-footnote {
                font-size: var(--font-size-footnote);
                font-weight: 400;
                color: var(--color-text-tertiary);
                line-height: 1.38;
                margin: var(--spacing-xs) 0 0 0;
              }

              /* === FORM ELEMENTS === */
              .apple-calc-input-group {
                margin-bottom: var(--spacing-lg);
              }

              .apple-calc-label {
                display: block;
                font-size: var(--font-size-headline);
                font-weight: 600;
                color: var(--color-text-primary);
                margin-bottom: var(--spacing-xs);
                line-height: 1.4;
              }

              .apple-calc-input {
                width: 100%;
                font-family: var(--font-family-system);
                font-size: var(--font-size-body);
                padding: var(--spacing-md);
                border: 1px solid var(--color-border);
                border-radius: var(--radius-md);
                background: var(--color-bg-primary);
                color: var(--color-text-primary);
                box-sizing: border-box;
                transition: all 0.2s ease;
                outline: none;
                appearance: none;
              }

              .apple-calc-input:focus {
                border-color: var(--color-primary);
                box-shadow: 0 0 0 3px rgba(255, 90, 90, 0.1);
              }

              .apple-calc-input::placeholder {
                color: var(--color-text-tertiary);
              }

              .apple-calc-input:disabled {
                background: var(--color-bg-secondary);
                color: var(--color-text-tertiary);
                cursor: not-allowed;
              }

              /* === SLIDER === */
              .apple-calc-slider-container {
                margin-bottom: var(--spacing-lg);
                /* Ensure stable width and prevent horizontal scrolling */
                width: 100%;
                max-width: 100%;
                box-sizing: border-box;
                overflow-x: hidden;
                /* Critical for mobile touch interaction */
                touch-action: pan-y pinch-zoom;
              }

              .apple-calc-slider-value {
                display: block;
                font-size: var(--font-size-title-3);
                font-weight: 600;
                color: var(--color-primary);
                text-align: center;
                margin-bottom: var(--spacing-md);
                padding: var(--spacing-sm);
                background: var(--color-bg-secondary);
                border-radius: var(--radius-sm);
                width: 100%;
                box-sizing: border-box;
              }

              .apple-calc-slider {
                width: 100%;
                height: 4px;
                border-radius: 2px;
                background: var(--color-bg-tertiary);
                outline: none;
                appearance: none;
                cursor: pointer;
                transition: all 0.2s ease;
                /* Critical: Allow only horizontal manipulation on touch devices */
                touch-action: pan-x;
                /* Ensure proper sizing */
                box-sizing: border-box;
                max-width: 100%;
                /* Prevent any margin/padding issues */
                margin: 0;
                padding: 0;
              }

              @media (max-width: 768px) {
                .apple-calc-slider {
                  /* Increased height for better mobile touch target */
                  height: 8px;
                  /* More specific touch action for mobile */
                  touch-action: pan-x;
                  /* Prevent text selection during drag */
                  user-select: none;
                  -webkit-user-select: none;
                  -moz-user-select: none;
                  -ms-user-select: none;
                }
                
                .apple-calc-slider-container {
                  /* Ensure container doesn't cause horizontal scroll */
                  width: 100%;
                  max-width: 100%;
                  margin-left: 0;
                  margin-right: 0;
                  padding-left: 0;
                  padding-right: 0;
                  /* Only allow vertical pan and pinch zoom on container */
                  touch-action: pan-y pinch-zoom;
                }
              }

              .apple-calc-slider::-webkit-slider-thumb {
                appearance: none;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: var(--color-primary);
                cursor: pointer;
                border: 3px solid white;
                box-shadow: var(--shadow-sm);
                transition: all 0.2s ease;
                /* Prevent touch scrolling issues */
                touch-action: pan-x;
              }

              .apple-calc-slider::-webkit-slider-thumb:hover {
                transform: scale(1.1);
                box-shadow: var(--shadow-md);
              }

              .apple-calc-slider::-moz-range-thumb {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                background: var(--color-primary);
                cursor: pointer;
                border: 3px solid white;
                box-shadow: var(--shadow-sm);
                appearance: none;
                transition: all 0.2s ease;
                /* Prevent touch scrolling issues */
                touch-action: pan-x;
              }

              @media (max-width: 768px) {
                .apple-calc-slider::-webkit-slider-thumb {
                  /* Larger touch target for mobile */
                  width: 32px;
                  height: 32px;
                  /* Better touch handling */
                  touch-action: pan-x;
                  /* Prevent text selection */
                  user-select: none;
                  -webkit-user-select: none;
                }
                
                .apple-calc-slider::-moz-range-thumb {
                  /* Larger touch target for mobile */
                  width: 32px;
                  height: 32px;
                  /* Better touch handling */
                  touch-action: pan-x;
                  /* Prevent text selection */
                  user-select: none;
                  -moz-user-select: none;
                }
              }

              /* === RESULTS === */
              .apple-calc-result-section {
                margin-bottom: var(--spacing-lg);
                padding-bottom: var(--spacing-lg);
                border-bottom: 1px solid var(--color-separator);
              }

              .apple-calc-result-section:last-child {
                margin-bottom: 0;
                padding-bottom: 0;
                border-bottom: none;
              }

              .apple-calc-result-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: var(--spacing-sm);
              }

              .apple-calc-result-row:last-child {
                margin-bottom: 0;
              }

              .apple-calc-result-label {
                font-size: var(--font-size-body);
                color: var(--color-text-primary);
                font-weight: 400;
              }

              .apple-calc-result-value {
                font-size: var(--font-size-body);
                color: var(--color-text-primary);
                font-weight: 600;
              }

              .apple-calc-result-value-primary {
                font-size: var(--font-size-title-3);
                color: var(--color-primary);
                font-weight: 700;
              }

              .apple-calc-result-sublabel {
                font-size: var(--font-size-footnote);
                color: var(--color-text-secondary);
                font-weight: 400;
              }

              /* === CALL TO ACTION === */
              .apple-calc-cta {
                background: var(--color-bg-secondary);
                border-radius: var(--radius-lg);
                padding: var(--spacing-xl);
                margin-top: var(--spacing-xxl);
                border: 1px solid var(--color-separator);
                text-align: center;
              }

              .apple-calc-cta-title {
                font-size: var(--font-size-title-2);
                font-weight: 700;
                color: var(--color-text-primary);
                margin-bottom: var(--spacing-sm);
                line-height: 1.3;
              }

              .apple-calc-cta-description {
                font-size: var(--font-size-body);
                color: var(--color-text-secondary);
                margin-bottom: var(--spacing-lg);
                line-height: 1.47;
              }

              .apple-calc-cta-button {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-family: var(--font-family-system);
                font-size: var(--font-size-headline);
                font-weight: 600;
                color: white;
                background: var(--color-primary);
                border: none;
                border-radius: var(--radius-md);
                padding: var(--spacing-md) var(--spacing-xl);
                cursor: pointer;
                transition: all 0.2s ease;
                text-decoration: none;
                min-height: 44px;
                margin-bottom: var(--spacing-md);
              }

              .apple-calc-cta-button:hover {
                background: var(--color-primary-hover);
                color: white;
                transform: translateY(-1px);
                box-shadow: var(--shadow-lg);
              }

              .apple-calc-cta-button:active {
                transform: translateY(0);
                box-shadow: var(--shadow-sm);
              }

              .apple-calc-cta-links {
                display: flex;
                flex-direction: column;
                gap: var(--spacing-sm);
                margin-top: var(--spacing-md);
              }

              .apple-calc-help-link {
                display: block;
                font-family: var(--font-family-system);
                font-size: var(--font-size-footnote);
                font-weight: 400;
                color: var(--color-primary);
                text-decoration: underline;
                text-align: center;
                transition: color 0.2s ease;
                margin-top: var(--spacing-sm);
                width: 100%;
              }

              .apple-calc-help-link:hover {
                color: var(--color-primary-hover);
                text-decoration: underline;
              }

              .apple-calc-cta-link {
                font-size: var(--font-size-subhead);
                color: var(--color-primary);
                text-decoration: none;
                font-weight: 500;
                padding: var(--spacing-sm);
                border-radius: var(--radius-sm);
                transition: background 0.2s ease;
              }

              .apple-calc-cta-link:hover,
              .apple-calc-cta-link:focus {
                background: rgba(255, 90, 90, 0.1);
                outline: none;
              }

              /* === INFO BOX === */
              .apple-calc-info {
                background: rgba(255, 90, 90, 0.05);
                border: 1px solid rgba(255, 90, 90, 0.2);
                border-radius: var(--radius-md);
                padding: var(--spacing-md);
                margin-top: var(--spacing-lg);
                display: flex;
                gap: var(--spacing-sm);
                align-items: flex-start;
              }

              .apple-calc-info-icon {
                font-size: 20px;
                color: var(--color-primary);
                flex-shrink: 0;
                margin-top: 2px;
              }

              .apple-calc-info-content {
                font-size: var(--font-size-footnote);
                color: var(--color-text-primary);
                line-height: 1.4;
              }

              .apple-calc-info-list {
                margin: var(--spacing-xs) 0;
                padding-left: var(--spacing-md);
              }

              .apple-calc-info-list li {
                margin-bottom: var(--spacing-xs);
              }

              /* === HINT TEXT === */
              .apple-calc-hint {
                font-size: var(--font-size-footnote);
                color: var(--color-text-tertiary);
                margin-top: var(--spacing-xs);
                line-height: 1.38;
              }

              /* === RESPONSIVE === */
              @media (max-width: 480px) {
                .apple-calc-container {
                  padding: var(--spacing-md);
                }
                
                .apple-calc-card {
                  padding: var(--spacing-lg);
                }
                
                .apple-calc-title-1 {
                  font-size: 24px;
                }
                
                .apple-calc-title-2 {
                  font-size: 20px;
                }
              }
            `}
          </style>

          {/* Calculator with Apple HIG design */}
          <div className={!isMobile && "apple-calc-container"}>
            <SalaryCalculator
              inputClass="apple-calc-input"
              labelClass="apple-calc-label"
              sliderClass="apple-calc-slider"
              sliderContainerClass="apple-calc-slider-container"
              sliderValueClass="apple-calc-slider-value"
              resultClass="apple-calc-result"
            />

            <div className="apple-calc-cta" role="region" aria-label="Hitta uppdrag och ersättningar">
              <div className="apple-calc-cta-title">Hitta uppdrag och ersättningar</div>
              <div className="apple-calc-cta-description">
                Filtrera bland aktuella uppdrag eller skapa ett konto för att bli matchad med rätt arbetsgivare – allt på samma plats.
              </div>
              <a
                href="https://staffi.se"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Se aktuella uppdrag med ersättningar - Hitta lediga jobb inom vården"
                className="apple-calc-cta-button"
                style={{ textDecoration: 'none' }}
              >
                Se aktuella uppdrag med ersättningar
              </a>
              <a
                href={REGISTRATION_PATH}
                className="apple-calc-help-link"
                aria-label="Registrera dig för att bli matchad med rätt uppdrag"
              >
                Få hjälp att bli matchad med rätt uppdrag
              </a>
            </div>

            {/* Related Articles Section */}
            <div className="apple-calc-card" style={{ marginTop: '32px' }}>
              <div className="apple-calc-card-header">
                <h2 className="apple-calc-title-2" style={{ textAlign: 'center' }}>
                  Relaterade löneartiklar för vårdkonsulter
                </h2>
              </div>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: isMobile ? '16px' : '20px',
                padding: isMobile ? '0 8px 8px 8px' : '0 16px 16px 16px'
              }}>
                {[
                  {
                    title: 'Lön för specialistläkare', 
                    description: 'Komplett guide till löner och ersättningar för specialistläkare inom alla medicinska områden',
                    link: SPECIALIST_DOCTOR_SALARY_PATH,
                    icon: '🏥'
                  },
                  {
                    title: 'Lön för sjuksköterskor',
                    description: 'Lönestatistik och karriärmöjligheter för sjuksköterskor i Sverige',
                    link: NURSE_SALARY_PATH,
                    icon: '👩‍⚕️'
                  },
                  {
                    title: 'Lön för hyrsjuksköterskor',
                    description: 'Jämför timersättningar för hyrsjuksköterskor och lär dig hur du kan beräkna lön baserat på fakturering',
                    link: TEMP_NURSE_SALARY_PATH,
                    icon: '💼'
                  },
                  {
                    title: 'Lön för hyrläkare',
                    description: 'Jämför ersättningar för hyrläkare och lär dig hur du kan beräkna lön baserat på fakturering',
                    link: TEMP_DOCTOR_SALARY_PATH,
                    icon: '🩺'
                  }
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(item.link);
                    }}
                    rel="noopener"
                    aria-label={`${item.title} - ${item.description}`}
                    style={{
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                      borderRadius: isMobile ? '12px' : '16px',
                      padding: isMobile ? '20px' : '24px',
                      border: '1px solid #e9ecef',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'block'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(255,90,90,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
                    }}
                  >
                    <div style={{
                      fontSize: isMobile ? '1.8rem' : '2rem',
                      marginBottom: isMobile ? '10px' : '12px',
                      textAlign: 'center'
                    }}>
                      {item.icon}
                    </div>
                    <h3 style={{
                      color: '#2c3e50',
                      fontSize: isMobile ? '1rem' : '1.1rem',
                      fontWeight: '600',
                      marginBottom: isMobile ? '6px' : '8px',
                      textAlign: 'center',
                      lineHeight: '1.3'
                    }}>
                      {item.title}
                    </h3>
                    <p style={{
                      color: '#6c757d',
                      fontSize: isMobile ? '0.85rem' : '0.9rem',
                      lineHeight: '1.5',
                      textAlign: 'center',
                      margin: 0
                    }}>
                      {item.description}
                    </p>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>
      </AppContainer>
      <AppFooter />
    </>
  );
};

export default SalaryCalculatorPage;